import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt, Download, ExternalLink, ArrowLeft } from "lucide-react";
import { api, rupiah } from "../lib/api";
import { DashSide } from "./Dashboard";

export function MemberBilling() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Billing — MasTofa.com";
    api("/me/invoices")
      .then((r) => setRows(r || []))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  const download = async (inv) => {
    const token = localStorage.getItem("mastofa_token");
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/me/invoices/${inv.id}/pdf`;
    try {
      const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      const blob = await r.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${inv.number}.pdf`;
      link.click();
    } catch {
      alert("Gagal download PDF.");
    }
  };

  return (
    <div className="dashboard">
      <DashSide active="billing" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">
              <Receipt size={13} style={{ display: "inline", marginRight: 6 }} /> BILLING
            </span>
            <h1>Invoice & Riwayat Pembayaran</h1>
            <p>Semua invoice Anda tersimpan di sini. Klik download untuk mengunduh PDF resmi.</p>
          </div>
        </div>

        {loading && <p className="muted">Memuat…</p>}

        {!loading && rows.length === 0 && (
          <div className="empty-state" data-testid="billing-empty">
            <Receipt size={30} />
            <b>Belum ada invoice</b>
            <p>Invoice akan otomatis muncul di sini setelah Anda melakukan pembayaran.</p>
            <Link to="/courses" className="button">
              Jelajahi kursus <ExternalLink size={14} />
            </Link>
          </div>
        )}

        {!loading && rows.length > 0 && (
          <div className="billing-list" data-testid="billing-list">
            {rows.map((inv) => (
              <div key={inv.id} className="billing-card" data-testid={`billing-${inv.number}`}>
                <div className="billing-head">
                  <div>
                    <b>{inv.number}</b>
                    <small className="muted">{inv.invoice_date}</small>
                  </div>
                  <span className={`pill pill-${(inv.status || "paid").toLowerCase()}`}>
                    {inv.status}
                  </span>
                </div>
                <div className="billing-body">
                  <div>
                    <small className="muted">Layanan</small>
                    <span>{inv.items?.[0]?.title || "-"}</span>
                  </div>
                  <div>
                    <small className="muted">Metode</small>
                    <span>{inv.payment_method || "Duitku"}</span>
                  </div>
                  <div>
                    <small className="muted">Total</small>
                    <b>{rupiah(inv.total)}</b>
                  </div>
                </div>
                <div className="billing-actions">
                  <button className="button" onClick={() => download(inv)}
                    data-testid={`billing-download-${inv.number}`}>
                    <Download size={14} /> Download PDF
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: 32 }}>
          <Link to="/dashboard" className="text-link">
            <ArrowLeft size={14} /> Kembali ke Dashboard
          </Link>
        </div>
      </main>
    </div>
  );
}
